import { withInstall } from "../../utils/index"
import scIcon from './component/index'

export const ScIcon = withInstall(scIcon)